import React, { useCallback, useState } from 'react';
import { Flex, Modal, Typo, FileCard } from '../../ui';
import styled from 'styled-components';
import { media } from '../../utils/media';
import MediaBreadCrumbs from './components/MediaBreadcrumbs';
import FoldersDirectory from './components/FoldersDirectory';
import SearchMediaData from './components/SearchMediaData';
import { useMedia } from './hooks';
import { useTranslation } from 'react-i18next';

const FilesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 15px;
  margin-top: 25px;
  overflow: auto;
  width: 100%;
  cursor: pointer;

  ${media.lessThan('tablet')} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const MediaPicker = ({ saveAction, mediaType, isOpen, closeModal }) => {
  const { t } = useTranslation();

  const [selectedFolder, setSelectedFolder] = useState('0');
  const [query, setSearchQuery] = useState('');

  const { mediaData, isError } = useMedia({ directoryId: selectedFolder }, { skip: !isOpen });

  const breadcrumbs = (mediaData?.breadcrumbs || []).slice().reverse();
  const files = mediaData?.files || [];
  const folders = files.filter((item) => item.type === 'dir');

  const filteredFiles = files.filter((item) => {
    if (item.type === 'dir') return false;
    if (mediaType && mediaType !== 'all' && item.type !== mediaType) return false;
    if (query && !item.name.toLowerCase().includes(query.toLowerCase())) return false;
    return true;
  });

  const filteredFolders = folders.filter((folder) => !query || folder.name.toLowerCase().includes(query.toLowerCase()));

  const handleOpenFolder = (obj) => {
    setSearchQuery('');
    setSelectedFolder(obj?.id ? obj.id : '0');
  };

  const pickFile = useCallback(
    (file) => {
      saveAction({ id: file.id, url: file.url, name: file.name });
      closeModal();
    },
    [saveAction, closeModal]
  );

  const handlClose = (e) => {
    closeModal(e);
    setSelectedFolder(0);
  };

  return (
    <Modal width='600px' onClose={handlClose} open={isOpen}>
      <Flex direction='column' gap='20' align='flex-start'>
        <Flex direction='column' gap='20' align='flex-start' width='100%'>
          {/* we may need a hook for the search. need to investigate it */}
          <SearchMediaData setQuery={setSearchQuery} />

          <MediaBreadCrumbs onOpenFolder={handleOpenFolder} breadcrumbs={breadcrumbs} />
          <FoldersDirectory selectedFolder={selectedFolder} data={filteredFolders} openFolder={handleOpenFolder} directoryId={selectedFolder} />
        </Flex>
        <Flex direction='column' align='flex-start' width='100%'>
          <Typo.ContentSmallHeader $textAlign='left'>{t('media.files')}</Typo.ContentSmallHeader>
          {isError ? (
            <Typo.Text $textAlign='center'>{t('globals.genericError')}</Typo.Text>
          ) : (
            filteredFiles && (
              <FilesGrid>
                {filteredFiles?.map((file) => (
                  <FileCard file={file} key={file.id} onClick={pickFile} />
                ))}
              </FilesGrid>
            )
          )}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default MediaPicker;
